/* eslint-disable no-restricted-syntax */
import DegreesConversionEpic from 'bundles/epic/clients/__generated__/DegreesConversion';

// DDP Manual Copy Tests
// Note: no strings in this file are translated, that is intentional.
// We do not translate this English-only user text on our degrees.

// Positions here are 1-indexed to match the titles used in Contentful
// e.g. bannerAtAGlanceTitle1, bannerAtAGlanceDescription2, etc
const manualCopyTuitionText = {
  'meng-computer-engineering-dartmouth': {
    manualCopyTestType: 'tuition',
    epicParam: 'manualCopyDartmouth',
    position: 4,
    title: '$4,900 per course' as string,
    description: '($4,900 x 9 courses = $44,100), with pay-as-you-go tuition for each course' as string,
  },
  imba: {
    manualCopyTestType: 'tuition',
    epicParam: 'manualCopyImba',
    position: 4,
    title: 'Approx. $24k total tuition' as string,
    description: '$347 per credit hour' as string,
  },
  'master-of-science-data-science-boulder': {
    manualCopyTestType: 'tuition',
    epicParam: 'manualCopyBoulder',
    position: 2,
    title: '$525 (USD) per credit' as string,
    description: 'Flexible pay-as-you-go, per-course basis' as string,
  },
  'mba-illinois-tech': {
    manualCopyTestType: 'tuition',
    epicParam: 'manualCopyIllinoisTech',
    position: 4,
    title: 'Approx. $417 USD per credit' as string,
    description: 'About $417 x 36 credits = $15,000, with pay-as-you-go tuition for each course.' as string,
  },
} as const;

const manualCopyAtAGlance = {
  'ba-liberal-studies-georgetown': {
    manualCopyTestType: 'atAGlance' as const,
    epicParam: 'manualCopyGeorgetown' as const,
    atAGlance: [
      {
        title: '100% online',
        description: 'Learn when and where it works best for you.',
      },
      {
        title: 'Accredited diploma',
        description: 'Earn your credential from Georgetown University School of Continuing Studies.',
      },
      {
        title: 'Taught in English',
        description: 'Engage in group discussions with professors and peers.',
      },
      {
        title: '120 credit degree',
        description: 'Transfer up to 64 credits toward the 120 credit degree',
      },
      {
        title: '$400 USD/credit hour',
        description: 'Benefit from affordable tuition and flexible payments.',
      },
    ],
  },
  'bachelor-of-science-computer-science-london': {
    manualCopyTestType: 'atAGlance' as const,
    epicParam: 'manualCopyLondon' as const,
    atAGlance: [
      {
        title: '£13,276 to £19,767 total degree cost',
        description: 'Tuition varies by geographic location',
      },
      {
        title: '100% online learning',
        description: 'Hands-on learning from anywhere, no travel required',
      },
      {
        title: "Accredited Bachelor's degree",
        description: 'Offered by the University of London',
      },
      {
        title: 'Flexibility',
        description: 'Choose a study schedule that matches your commitments',
      },
      {
        title: '36 - 72 months',
        description: '23 courses total, 14 - 28 hours per week',
      },
    ],
  },
  omie: {
    manualCopyTestType: 'atAGlance' as const,
    epicParam: 'manualCopyOmie' as const,
    atAGlance: [
      {
        title: '#1 Business School in Europe',
        description: 'Ranked by the Financial Times for 4 consecutive years',
      },
      {
        title: 'Internationally-accredited',
        description: 'Triple accreditation from AMBA, EQUIS and AACSB',
      },
      {
        title: 'Taught in English',
        description: 'Engage in group discussions with professors and peers',
      },
      {
        title: '18-24 months',
        description: '20 courses total, 20 hours per week',
      },
      {
        title: '22,950-24,950 Euro total cost',
        description: '[Learn about your payment options](https://www.coursera.org/degrees/omie/tuition-financing)',
      },
    ],
  },
  'msc-management-huddersfield': {
    manualCopyTestType: 'atAGlance' as const,
    epicParam: 'manualCopyHuddersfield' as const,
    atAGlance: [
      {
        title: 'AACSB internationally-accredited',
        description: 'Globally, less than 6% of institutions offering business degrees achieve this accreditation',
      },
      {
        title: 'Performance-Based Admission',
        description:
          'Successfully [complete the first module](https://www.coursera.org/degrees/msc-management-huddersfield/admissions) to qualify for easy admission - no bachelor’s required',
      },
      {
        title: '24 months, part time',
        description: '7 modules and a 40-credit research project, 12-18 hours per week',
      },
      {
        title: '100% online',
        description:
          'Earn a prestigious degree from a world-renowned institution, without the impact of travel or having to be there in person',
      },
      {
        title: '£8,900 total cost',
        description:
          'No application fee. [Learn about your payment options](https://www.coursera.org/degrees/msc-management-huddersfield/tuition-financing)',
      },
    ],
  },
  'master-of-computer-science-illinois': {
    manualCopyTestType: 'atAGlance' as const,
    epicParam: 'manualCopyCompsciIllinois' as const,
    atAGlance: [
      {
        title: 'Accredited master’s degree',
        description: 'Offered by University of Illinois Urbana-Champaign',
      },
      {
        title: 'Finish in 12-36 months',
        description: '8 courses total, 10-12 hours per week',
      },
      {
        title: '$19,840 - $24,128 USD',
        description: 'Competitively priced with pay-as-you-go tuition',
      },
      {
        title: '100% online learning',
        description: 'Hands-on learning from anywhere, no travel required',
      },
    ],
  },
};

const manualCopyEoiTest = {
  'ms-data-analytics-engineering-northeastern': {
    manualCopyTestType: 'eoi',
    epicParam: 'manualCopyNortheastern',
    eoiDescription: '## Get started today\nComplete the Fast-App to determine your next steps.',
    applyEnrollBtn: 'Discover your path',
    eoiBtn: 'Request info',
  },
} as const;

type ManualCopyTuitionSlugs = keyof typeof manualCopyTuitionText;
type ManualCopyAtAGlanceSlugs = keyof typeof manualCopyAtAGlance;
type ManualCopyEoiTestSlugs = keyof typeof manualCopyEoiTest;

const isInTuitionTests = (slug: string): slug is ManualCopyTuitionSlugs =>
  [...Object.keys(manualCopyTuitionText)].includes(slug);

const isInAtAGlanceTests = (slug: string): slug is ManualCopyAtAGlanceSlugs =>
  [...Object.keys(manualCopyAtAGlance)].includes(slug);

const isInEoiTests = (slug: string): slug is ManualCopyEoiTestSlugs =>
  [...Object.keys(manualCopyEoiTest)].includes(slug);

export const getManualCopyTest = (slug: string) => {
  if (isInEoiTests(slug)) {
    return DegreesConversionEpic.get(manualCopyEoiTest[slug].epicParam) ? manualCopyEoiTest[slug] : undefined;
  } else if (isInTuitionTests(slug)) {
    return DegreesConversionEpic.get(manualCopyTuitionText[slug].epicParam) ? manualCopyTuitionText[slug] : undefined;
  } else if (isInAtAGlanceTests(slug)) {
    return DegreesConversionEpic.get(manualCopyAtAGlance[slug].epicParam) ? manualCopyAtAGlance[slug] : undefined;
  } else {
    return undefined;
  }
};
